<div>
  <span>{{ 'CUSTOMIZER.COMPONENTS.ADDTOINSPIRATION.VISIBLEFROM' | translate }}</span>
</div>
<div id="dateinput" [ngClass]="{'invalid': dateIsInvalid}">
  <input id="dayinput" placeholder="{{ 'CUSTOMIZER.COMPONENTS.ADDTOINSPIRATION.DD' | translate }}"
    [(ngModel)]="chosenReleaseDay" type="number">
    <input id="monthinput" placeholder="{{ 'CUSTOMIZER.COMPONENTS.ADDTOINSPIRATION.MM' | translate }}"
      [(ngModel)]="chosenReleaseMonth" type="number">
      <input id="yearinput" placeholder="{{ 'CUSTOMIZER.COMPONENTS.ADDTOINSPIRATION.YYYY' | translate }}"
        [(ngModel)]="chosenReleaseYear" type="number">
      </div>
      <div id="group">
        <select (change)="InspirationGroupChanged()" [(ngModel)]="chosenInspirationGroup" class="form-control">
          @for (group of inspirationgroups; track group) {
            <option [value]="group.Id">
              {{group.Name | translate}}
            </option>
          }
        </select>
        <button (click)="AddToInspirationGroup()" [disabled]="currentIsAddedToInspiration" class="btn btn-primary">
          {{ 'CUSTOMIZER.COMPONENTS.ADDTOINSPIRATION.ADD' | translate }}
        </button>
      </div>